// RemittanceOffice Mutations

export const updateRemittanceOfficeList = (state, payload) => {
  state.remittanceOfficeList = payload
}

export const fetchRemittanceOfficeInfo = (state, payload) => {
  state.remittanceOfficeInfo = payload
}

export const setFullRemittanceOfficesList = (state, payload) => {
  state.fullRemittanceList = payload
}
